
import { useState, useEffect } from 'react';
import { useToast } from "@/hooks/use-toast";
import { useLanguage } from "@/contexts/LanguageContext";
import { 
  validateLocations,
  validateDuration,
  validateCreatives,
  validateCampaignName,
  validateMediaOwnerCreatives,
  logValidationState,
  handleValidationFailure
} from '../utils/paymentValidationUtils';

export const usePaymentValidation = (
  selectedLocations: any[],
  duration: number,
  onResetToFirstStep?: () => void
) => {
  const [isFormValid, setIsFormValid] = useState(false);
  const { toast } = useToast();
  const { t } = useLanguage();

  useEffect(() => {
    // Validate that we have the required data
    let isValid = true;
    const validationErrors = [];

    // Run all validations and collect errors
    if (!validateLocations(selectedLocations)) {
      isValid = false;
      validationErrors.push('No locations selected');
    }

    if (!validateDuration(duration)) {
      isValid = false;
      validationErrors.push('Invalid campaign duration');
    }

    if (!validateCreatives()) {
      isValid = false;
      validationErrors.push('No creative assets uploaded');
    }

    if (!validateCampaignName()) {
      isValid = false;
      validationErrors.push('No campaign name provided');
    }

    if (!validateMediaOwnerCreatives(selectedLocations)) {
      isValid = false;
      validationErrors.push('Missing creatives for media owners');
    }

    // Log validation state for debugging
    logValidationState(isValid, selectedLocations, duration, validationErrors);

    // Handle validation failure
    if (!isValid) {
      handleValidationFailure(validationErrors, t, toast, onResetToFirstStep);
    }

    setIsFormValid(isValid);
  }, [selectedLocations, duration, onResetToFirstStep, toast, t]);

  return { isFormValid };
};
